import React from 'react';
import { Grid, Paper, Typography, Link, Box } from '@material-ui/core';
import { Link as RouterLink, useHistory, useRouteMatch } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Page, AppBar } from 'components';
import { backNavigationStore } from 'stores';
import { ru } from 'locale';
import sections from './KFAnalyticsScreen.mock';
import useStyles from './KFAnalyticsScreen.styles';

const KFAnalyticsScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { url } = useRouteMatch();
  const { backUrl } = backNavigationStore;
  const items = sections;

  const handleBackClick = () => {
    history.goBack();
  };

  const renderItems = () => {
    return items.map(item => {
      const Icon = item.icon;

      return (
        <Grid item xs={6} key={item.name}>
          <Link component={RouterLink} to={`${url}/${item.url}`}>
            <Paper className={classes.card}>
              <Icon className={classes.icon} />
              <Typography variant="body2" className={classes.title}>
                {item.name}
              </Typography>
            </Paper>
          </Link>
        </Grid>
      );
    });
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }} className={classes.root}>
      <Grid container direction="column">
        <Grid item>
          <AppBar
            title={ru.kfAnalytics}
            onNavButtonClick={handleBackClick}
            backUrl={`${backUrl}#kf-analytics`}
            typeNavIcon="link"
          />
        </Grid>
        <Box m={2}>
          <Grid container spacing={2}>
            {renderItems()}
          </Grid>
        </Box>
      </Grid>
    </Page>
  );
});

export default KFAnalyticsScreen;
